import React from 'react';
import { ModalView } from '../ModalView';
import Stack from '../Stack';
import Button from '../Button';
import Icon from '../Icon';
import Information from '../Information';
import Text from '../Text';
import StyledContainer from '../StyledContainer';
import Timer from './Timer';
import setTimeoutWorker from './setTimeout.worker';

const SHOW_MODAL_BEFORE_EXPIRES_MILLISECONDS = 60000;
const UPDATE_TOKEN_BEFORE_EXPIRES_MILLISECONDS = 600000;

class SessionTimeoutModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      updateTokenTimestamp: null,
    };

    this.setTimeoutWorker = new Worker(setTimeoutWorker);
  }

  componentDidMount() {
    this.addListeners();

    this.setTimeoutWorker.onmessage = () => {
      this.removeListeners();
      this.setState({ isOpen: true });
    };

    this.setTimers();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sessionExpiration !== this.props.sessionExpiration
    ) {
      this.setTimers();
    }
  }

  componentWillUnmount() {
    this.removeListeners();
    this.setTimeoutWorker.terminate();
  }

  setTimers = () => {
    const currentTime = new Date().getTime();
    const sessionExpTimestamp = new Date(this.props.sessionExpiration).getTime();
    this.setUpdateTokenTimestamp(sessionExpTimestamp);
    this.setState({ isOpen: false });

    this.setTimeoutWorker.postMessage({
      delay: sessionExpTimestamp - currentTime - SHOW_MODAL_BEFORE_EXPIRES_MILLISECONDS,
    });
  }

  addListeners = () => {
    document.addEventListener('keydown', this.handleUserAction, true);
    document.addEventListener('click', this.handleUserAction, true);
  }

  removeListeners = () => {
    document.removeEventListener('keydown', this.handleUserAction, true);
    document.removeEventListener('click', this.handleUserAction, true);
  }

  setUpdateTokenTimestamp = (sessionExpTimestamp) => {
    this.setState({ updateTokenTimestamp: sessionExpTimestamp - UPDATE_TOKEN_BEFORE_EXPIRES_MILLISECONDS });
  }

  handleUserAction = () => {
    const { updateTokenPending, onUpdateToken } = this.props;
    const { updateTokenTimestamp } = this.state;
    const currentTime = new Date().getTime();

    if (updateTokenTimestamp && (currentTime > updateTokenTimestamp) && !updateTokenPending) {
      onUpdateToken();
    }
  };

  render() {
    const { t, onUpdateToken, sessionExpiration, onLogout } = this.props;
    const { isOpen } = this.state;

    return isOpen ? (
      <ModalView
        dataId="SessionTimeoutModal"
        title={t('SessionTimeoutModal.title')}
        actions={(
          <Stack spacing="narrow" horizontalAlignment="right" verticalAlignment="center">
            <Stack.Item>
              <Button
                text={t('SessionTimeoutModal.buttons.log-out')}
                appearance="default"
                onClick={onLogout}
              />
            </Stack.Item>
            <Stack.Item>
              <Button
                text={t('SessionTimeoutModal.buttons.keep-logged-in')}
                appearance="primary"
                onClick={() => {
                  onUpdateToken();
                  this.setState({ isOpen: false });
                  this.addListeners();
                }}
              />
            </Stack.Item>
          </Stack>
        )}
      >
        <Stack vertical horizontalAlignment="middle">
          <Stack.Item>
            <Icon
              name="alerts"
              color="yellow"
              size="medium"
            />
          </Stack.Item>
          <Stack.Item>
            <Text>{t('SessionTimeoutModal.content-1')}</Text>
          </Stack.Item>
          <Stack.Item>
            <StyledContainer backgroundColor="gray" border={['left', 'right', 'top', 'bottom']} padding="narrow">
              <Timer onTimeIsUp={onLogout} timeIsUpTimestamp={new Date(sessionExpiration).getTime()} />
            </StyledContainer>
          </Stack.Item>
          <Stack.Item>
            <Text>{t('SessionTimeoutModal.content-2')}</Text>
          </Stack.Item>
          <Stack.Item fill previousSpacing="wide">
            <Information type="info">{t('SessionTimeoutModal.settings-info')}</Information>
          </Stack.Item>
        </Stack>
      </ModalView>
    ) : null;
  }
}

SessionTimeoutModal.defaultProps = {
  updateTokenPending: false,
};

export default SessionTimeoutModal;
